import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiGeeksforgeeks,
  SiGithub,
  SiMedium,
  SiCodechef,
  SiLeetcode,
} from "react-icons/si";

function CodingWebsiteStack() {
  return (
    <div class="card">
  <div class="card-header" style={{textAlign:"left"}}>
    <h3>Coding Profiles</h3>
  </div>
    <Row style={{ justifyContent: "center", padding: "30px" }}>
        <a  href='https://github.com/deeppatel23' target='blank_' title="Githib">
            <Col  xs={4} md={4} className="tech-icons">
                <SiGithub style={{color:"#222"}} title="Github"/>
            </Col>
        </a>

        <a href='https://www.codechef.com/users/deep_patel23' target='blank_' title="CodeChef">
            <Col xs={4} md={4} className="tech-icons">
                <SiCodechef style={{color:"#222"}} title="CodeChef"/>
            </Col>
        </a>

        <a href='https://leetcode.com/deep_patel23/' target='blank_' title="Githib">
            <Col  xs={4} md={4} className="tech-icons">
                <SiLeetcode style={{color:"#222"}} title="Leetcode"/>
            </Col>
        </a>

        <a href='https://deeppatel23.medium.com/' target='blank_' title="CodeChef">
            <Col xs={4} md={4} className="tech-icons">
                <SiMedium style={{color:"#222"}} title="Medium"/>
            </Col>
        </a>


        <a  href='https://auth.geeksforgeeks.org/user/deep_patel23/practice/' target='blank_' title="Geeksforgeeks">
            <Col  xs={4} md={4} className="tech-icons">
                <SiGeeksforgeeks style={{color:"#222"}} title="Geeksforgeeks"/>
            </Col>
        </a>
    </Row>
    </div>
  );
}

export default CodingWebsiteStack;
